import Input from '@/components/Input.vue';
import InputMask from '@/components/InputMask';
import Select from '@/components/Select';
import Combobox from '@/components/Combobox';
import CheckBox from '@/components/CheckBox';
import CheckBoxCustom from '@/components/CheckBoxCustom';
import Radio from '@/components/Radio';
import TextArea from '@/components/TextArea';
import Validator from '@/components/Valitador';
import FormBasico from '@/components/FormBasico';
import DataGrid from '@/components/DataGrid';
import SigedAlert from '@/assets/js/sigedalert';
import FormatDataBR from './filters/formatDataBR';
import formatDataBRDia from './filters/formatDataBRDia';
import formatNumber from './filters/formatNumber';
import nomeTurno from './filters/nomeTurno';
import MultipleSelect from '@/components/MultipleSelect';
import InputDate from '@/components/InputDate.vue';
import InputDateTable from '@/components/InputDateTable.vue';
import Validate from '@/components/Validate';

const GlobalPlugin = {
  install(Vue) {
    Vue.component('Input', Input);
    Vue.component('InputMask', InputMask);
    Vue.component('Select', Select);
    Vue.component('Combobox', Combobox);
    Vue.component('CheckBox', CheckBox);
    Vue.component('CheckBoxCustom', CheckBoxCustom);
    Vue.component('Radio', Radio);
    Vue.component('Validator', Validator);
    Vue.component('FormBasico', FormBasico);
    Vue.component('DataGrid', DataGrid);
    Vue.component('TextArea', TextArea);
    Vue.component('MultipleSelect', MultipleSelect);
    Vue.component('InputDate', InputDate);
    Vue.component('InputDateTable', InputDateTable);
    Vue.component('Validate', Validate);

    Vue.prototype.$sgal = SigedAlert;

    Vue.filter('formatDataBR', FormatDataBR);
    Vue.filter('formatDataBRDia', formatDataBRDia);
    Vue.filter('formatNumber', formatNumber);
    Vue.filter('nomeTurno', nomeTurno);
  },
};

export default GlobalPlugin;
